import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { SecuritiesPropertyHistoric } from 'src/app/models/securities-property/securities-property-historic';
import { SecuritiesPropertyService } from 'src/app/services/securities-property/securities-property.service';
import { MessageUtil } from 'src/app/utils/message.util';

@Component({
  selector: 'app-invite-historic-dialog',
  templateUrl: './invite-historic-dialog.component.html',
  styleUrls: ['./invite-historic-dialog.component.scss'],
})
export class InviteHistoricDialogComponent implements OnInit {
  securitiesPropertyId: number | null = null;
  year: number | null = null;
  rows: SecuritiesPropertyHistoric[] = [];

  readonly addInviteAction = 'add invite to buy';
  readonly addFreeInviteAction = 'add free invite';

  constructor(
    private config: DynamicDialogConfig,
    private securitiesPropertyService: SecuritiesPropertyService,
    private spinner: NgxSpinnerService,
    private messageUtil: MessageUtil
  ) {}

  ngOnInit(): void {
    this.securitiesPropertyId = this.config?.data?.securitiesPropertyId ?? null;
    this.year = this.config?.data?.year ?? null;
    if (this.securitiesPropertyId == null) {
      return;
    }
    this.loadHistoric();
  }

  get addInviteToBuyCount(): number {
    return this.rows
      .filter((r) => this.normalizeAction(r.action) === this.addInviteAction)
      .reduce((total, row) => total + (row.numberInviteToBuy ?? 0), 0);
  }

  get addFreeInviteCount(): number {
    return this.rows
      .filter((r) => this.normalizeAction(r.action) === this.addFreeInviteAction)
      .reduce((total, row) => total + (row.numberInviteToBuy ?? 0), 0);
  }

  canBlock(row: SecuritiesPropertyHistoric): boolean {
    const action = this.normalizeAction(row?.action);
    return !row?.block && action === this.addInviteAction;
  }

  blockHistoric(row: SecuritiesPropertyHistoric): void {
    if (!row?.id || row.block) {
      return;
    }
    this.spinner.show();
    this.securitiesPropertyService.blockInviteHistoric(row.id).subscribe({
      next: () => {
        this.spinner.hide();
        row.block = true;
        this.messageUtil.generateMessage('success', 'Sucesso', 'Registro bloqueado com sucesso.');
      },
      error: (error) => {
        this.spinner.hide();
        const ex = error?.error?.data?.exception;
        if (ex) {
          this.messageUtil.generateMessage(ex.type, ex.title, ex.message);
        } else {
          this.messageUtil.generateMessage('error', 'Erro', 'Não foi possível bloquear o registro.');
        }
      },
    });
  }

  private loadHistoric(): void {
    this.securitiesPropertyService.getHistoric(this.securitiesPropertyId!).subscribe({
      next: (data) => {
        const allRows = data ?? [];
        this.rows = allRows.filter((row) => {
          const action = this.normalizeAction(row.action);
          const rowDate = row.dateStart ? new Date(row.dateStart) : null;
          const yearMatch = this.year == null
            || (rowDate != null && !isNaN(rowDate.getTime()) && rowDate.getFullYear() === this.year);
          return (action === this.addInviteAction || action === this.addFreeInviteAction) && yearMatch;
        });
      },
      error: (error) => {
        const ex = error?.error?.data?.exception;
        if (ex) {
          this.messageUtil.generateMessage(ex.type, ex.title, ex.message);
        } else {
          this.messageUtil.generateMessage('error', 'Erro', 'Não foi possível carregar o histórico.');
        }
      },
    });
  }

  private normalizeAction(action: string | null | undefined): string {
    return (action ?? '').trim().toLowerCase();
  }
}
